export default "__VITE_ASSET__CfLDmvJ8__"